<template>
	<div class="">
		<base-page-heading
			title="Cross Sell"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="crossSellShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<CrossSellTable @routeCrossSell="routeCrossSell" />
		</div>
	</div>
</template>
